/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
const NS = 'SiteFooterSitemap';
const CLS = 'siteFooterSitemap';
const WG = '.' + CLS + '-';

import {scrollIntoView} from 'scroll-js';

export class SiteFooterSitemap {
	constructor($el) {
		this.$el = $el;
	}

	init() {
		const $wg = $(this.$el);
		this.slideAnimationDuration = 750;
		this.scrollAnimationDuration = 750;
		this.scrollEasing = 'ease-in-out';
		this.isAnimating = false;
		let $siteFooter = $wg.parents('.siteFooter');

		$wg.on('siteFooterSitemap.toggle', () => {
			if (!this.isAnimating) {
				if ($wg.attr('data-closed') === 'true') {
					$wg.attr('data-closed', false);
					$siteFooter.trigger('siteFooter.sitemapButton.toggleClass', {});
					this.isAnimating = true;
					$wg.slideDown({
						duration: this.slideAnimationDuration,
						complete: () => {
							scrollIntoView($wg[0], document.body, {duration: this.scrollAnimationDuration, easing: this.scrollEasing}).then(() => {
								this.isAnimating = false;
							});
						},
					});
				} else {
					this.isAnimating = true;
					$wg.slideUp({
						duration: this.slideAnimationDuration,
						complete: () => {
							$wg.attr('data-closed', true);
							$siteFooter.trigger('siteFooter.sitemapButton.toggleClass', {});
								this.isAnimating = false;
						},
					});
				}
			}
		});

		$wg.on('click', WG + 'close', () => {
			this.isAnimating = false;
			$wg.trigger('siteFooterSitemap.toggle');
		});
	}
}
